import React, { Component } from 'react';
import { weekDayAndHour, msToHour } from '../../../../lib/date.utils';
import { selectSubstring } from '../../../../lib/string.utils';

class ResultsItem extends Component {
    _onClick = () => {
        this.props.onClick(this.props.entry);
    };
    render() {
        const artist = this.props.entry.Artist;
        const highlight = selectSubstring((artist && artist.name) || '', this.props.query);
        return (
            <li onClick={this._onClick} key={this.props.entry.id} className="ckp-events-search-item">
                <span className="ckp-events-search-artist">
                    {highlight[0]}
                    <span className="ckp-events-search-highlight">{highlight[1]}</span>
                    {highlight[2]}
                </span>
                <span className="ckp-events-search-date">
                    {weekDayAndHour(
                        this.props.entry.date,
                        msToHour(this.props.entry.startHour),
                        msToHour(this.props.entry.endHour),
                        true
                    )}
                </span>
                <span className="ckp-events-search-stage">{this.props.entry.stage}</span>
            </li>
        );
    }
}

export default ResultsItem;
